import {createSlice} from "@reduxjs/toolkit";
import {ENTITY_TYPE} from "utils/entities";
import {
  clearIncidentDetail,
  getIncident,
  getIncidentFailure
} from "./incidentDetailSlice";

const initialState = {
  eventsCount: 0,
  loading: false,
  loadingEntitiesByType: false,
  firstEventDate: null,
  lastEventDate: null,
  linkedIncidents: [],
  linkedReferences: {
    snapshotsCount: 0,
    incidentsCount: 0,
    indicatorsCount: 0,
    casebooksCount: 0,
    totalCount: 0
  },
  assets: {data: [], totalCount: 0},
  indicators: {data: [], totalCount: 0},
  mitreData: {data: [], totalCount: 0},
  observables: {data: [], totalCount: 0},
  severity: {data: [], totalCount: 0},
  items: {},
  groups: {},
  graphInitialized: false,
  primaryInvestigation: {
    id: null,
    description: null,
    short_description: null,
    source: null
  },
  entitiesByType: {[ENTITY_TYPE.assets]: [], [ENTITY_TYPE.observables]: []}
};

export const incidentOverviewSlice = createSlice({
  name: "incidentOverview",
  initialState,
  reducers: {
    getIncidentSummary: (state) => {
      state.loading = true;
      state.loadingEntitiesByType = true;
    },
    getIncidentSummarySuccess: (state, action) => ({
      ...action.payload,
      linkedIncidents: (action.payload.linkedIncidents || []).filter(
        (incident) => incident.id !== action.payload.incident.id
      ),
      loading: false,
      graphInitialized: true
    }),
    getIncidentSummaryFailure: (state) => {
      state.loading = false;
      state.loadingEntitiesByType = false;
    },
    getEntitiesByTypeSuccess: (state, action) => {
      state.loadingEntitiesByType = false;
      state.entitiesByType = {...action.payload};
    },
    getEntitiesByTypeFailure: (state) => {
      state.loadingEntitiesByType = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIncident, (state) => {
        state.loading = true;
        state.loadingEntitiesByType = true;
      })
      .addCase(getIncidentFailure, (state) => {
        state.loading = false;
        state.loadingEntitiesByType = false;
      })
      .addCase(clearIncidentDetail, () => initialState)
      .addDefaultCase(() => {});
  }
});

export const {
  getIncidentSummary,
  getIncidentSummarySuccess,
  getIncidentSummaryFailure,
  getEntitiesByTypeFailure,
  getEntitiesByTypeSuccess
} = incidentOverviewSlice.actions;

export default incidentOverviewSlice.reducer;
